// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vk9-","buttons":"styles_buttons__3Btmt"};